module.exports = {"configFile":"./config.json","apiUrl":"http://api.deadlineexpress.co.nz"};